import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './modules/App/AppContainer';
import Store from './redux/store';

import './styles/styles.scss';

const MapTool = () => (
  <Provider store={Store}>
    <App />
  </Provider>
);

class MaptoolApp {

  constructor(container) {
    /* console.log(
      '%c maptool: %c 2017-08-23 14:00 ',
      'background:grey;color:white;',
      'background:#ffc53e;color:#00489a;',
    ); */
    this.container = container;
    this.render();
  }

  render() {
    ReactDOM.render(
      <MapTool />,
      this.container
    );
  }

  destroy() {
    ReactDOM.unmountComponentAtNode(this.container);
  }

  rerender() {
    this.destroy();
    this.render();
  }
}

window.maptoolapp = new MaptoolApp(document.getElementById('maptool'));



/** WEBPACK FOOTER **
 ** ./apps/maptool/index.js
 **/